<div class="sidebar">
    <img src="assets/img/global-login-logo.png" />
</div>

